'use strict';
// JBB - 2024-02-21 - let klaviyo know about logged-in users. 'klaviyo_email_address' should be available on the user account page (seen after login), and the homepage (seen after registration).

// JBB - 2024-02-21 - Add this snippet so that calls to the klaviyo object don't fail if the klaviyo object isn't available yet. https://developers.klaviyo.com/en/v1-2/docs/introduction-to-the-klaviyo-object
/* eslint-disable */
!function(){if(!window.klaviyo){window._klOnsite=window._klOnsite||[];try{window.klaviyo=new Proxy({},{get:function(n,i){return"push"===i?function(){var n;(n=window._klOnsite).push.apply(n,arguments)}:function(){for(var n=arguments.length,o=new Array(n),w=0;w<n;w++)o[w]=arguments[w];var t="function"==typeof o[o.length-1]?o.pop():void 0,e=new Promise((function(n){window._klOnsite.push([i].concat(o,[function(i){t&&t(i),n(i)}]))}));return e}}})}catch(n){window.klaviyo=window.klaviyo||[],window.klaviyo.push=function(){var n;(n=window._klOnsite).push.apply(n,arguments)}}}}();
/* eslint-enable */

(function(jQuery, Drupal) {
  Drupal.behaviors.nowLogin = {
    attach: function(context, settings) {
      let $email_address = jQuery("[name='klaviyo_email_address']").first();
      if ($email_address.val()) {
        var klaviyo = window.klaviyo || [];
        klaviyo.push(['identify', {
          '$email': $email_address.val()
        }]);
      }
    }
  };
})(jQuery, Drupal);
